module.exports = __webpack_public_path__ + "static/img/85117F_2_3_R_20181116_fit.d8bd9f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85117F_2_3_R_20181116_fit.png
// module id = QUE5
// module chunks = 0